import List from './Alerts';
import Details from './AlertsDetails';

export default {
  List,
  Details,
};
